export default {
  banner: {
    description: 'Saat {{range}} alennusta tilatessasi ilmaisen FoodAmigos-sovelluksen kautta. Lataa sovellus täältä →',
  },
  labels: {
    deals: 'Tarjoukset',
    collecting_points: 'Keräätkö jo pisteitä?',
    earn_points: 'Ansaitse pisteitä ja saa palkintoja ',
    order_again: 'Tilaa uudelleen',
  },
  checkout_button: {
    title: 'Siirry ostoskoriin',
  },
};
